import * as api from 'services/auth';
import * as CST from './constants';
import { axiosTokenSetup } from 'config/axios';
import { makeApiActionCreator, makeStandardActionCreator } from 'reducers/action-helpers';

// ACTION CREATORS
const userUpdated = makeStandardActionCreator(CST.USER_UPDATED);

// ASYNC ACTION CREATORS
export const updateUserInfo = makeApiActionCreator(api.updateUserInfo, userUpdated);

export const authenticateUser = userData => dispatch => {
  axiosTokenSetup(userData);
  dispatch(userAuthenticated(userData));
};

export const cadastrarUsuario = info => dispatch => {
  return api.cadastrarUsuario(info)
    .then(({ data }) => {
      if (data.confirmacaoPendente) {
        return data;
      } else {
        dispatch(authenticateUser(data));
        return { confirmacaoPendente: false };
      }
    });
};

export const login = (username, password) => dispatch => {
  return api.login(username, password)
    .then(({ data }) => dispatch(authenticateUser(data)));
};

export const logout = () => dispatch => {
  localStorage.removeItem(CST.USER_INFO);
  return api.logout()
    .then(() => dispatch(logoutAction()))
    .catch(() => dispatch(logoutAction()));
};

export const resetPassword = params => dispatch => {
  return api.resetPassword(params)
    .then(({ data }) => dispatch(authenticateUser(data)));
};

export const logoutAction = () => {
  return {
    type: CST.REVOKE_USER,
  };
};

// OLD-STYLE ACTION CREATORS
const userAuthenticated = user => {
  return {
    type: CST.AUTHENTICATE_USER,
    payload: {
      user,
    },
  };
};



// WEBPACK FOOTER //
// ./src/reducers/user/actions.js